import styled, { css } from 'foundations-theming-specialty/utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import ErrorBoundary from '../../ErrorBoundary';
import TrackedLink from '../../TrackedLink';
import { GlobalToolbarIcon } from './GlobalToolbarIcon';
import { StyledListItem } from './GlobalToolbarItem';
import useMenuItem from '../../Menu/hooks/useMenuItem';
import withTransientStyleProps from '../../../utils/withTransientStyleProps';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledLink = styled(withTransientStyleProps(TrackedLink))(({
  $additionalStyles,
  theme
}) => {
  return css(["display:flex;justify-content:center;align-items:center;white-space:nowrap;padding:8px !important;height:auto;border-radius:6px;&:hover{background:", ";svg{fill:", " !important;}.icon-text-key{color:", " !important;}}.icon-text-key{padding-left:8px !important;color:", " !important;font-size:13px !important;font-weight:400 !important;@media screen and (max-width:924px){display:none;}}", ""], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-icon-nav-item-hover'], theme.color['global-shell-text-nav-item-hover'], theme.color['global-shell-text-nav-item-default'], $additionalStyles || '');
});
export const GlobalToolbarLink = memoWithDisplayName('GlobalToolbarLink', ({
  id,
  itemName,
  iconName,
  iconTitleKey,
  iconPlacement = 'before',
  href,
  ariaLabelKey,
  tabIndex,
  testId,
  iconTextKey,
  target,
  onClick,
  portalHook,
  shouldRender = true,
  additionalStyles,
  additionalListItemStyles
}) => {
  const {
    t
  } = useTranslation();
  const ariaLabel = t(ariaLabelKey);
  const {
    setRef,
    onMenuItemKeyDown
  } = useMenuItem({
    id
  });
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: `Global Toolbar - ${itemName}`,
    children: /*#__PURE__*/_jsx(StyledListItem, {
      "data-portal-hook": portalHook,
      role: "menuitem",
      additionalStyles: additionalListItemStyles,
      children: /*#__PURE__*/_jsxs(StyledLink, {
        id: id,
        "data-test-id": testId || id,
        href: href,
        "aria-label": ariaLabel,
        tabIndex: tabIndex,
        onKeyDown: onMenuItemKeyDown,
        ref: setRef,
        onClick: onClick || (() => null),
        $additionalStyles: additionalStyles,
        target: target,
        children: [!iconPlacement || iconPlacement === 'before' ? /*#__PURE__*/_jsx(GlobalToolbarIcon, {
          name: iconName,
          titleKey: iconTitleKey || ariaLabelKey
        }) : null, iconTextKey ? /*#__PURE__*/_jsx("span", {
          className: "icon-text-key",
          children: t(iconTextKey)
        }) : null, iconPlacement === 'after' ? /*#__PURE__*/_jsx(GlobalToolbarIcon, {
          name: iconName,
          titleKey: iconTitleKey || ariaLabelKey
        }) : null]
      })
    })
  });
});